const CONST = {
    RESET: 'BRAND_COLOR_EXTRACTOR/RESET',
    UPDATE_STATE: 'BRAND_COLOR_EXTRACTOR/UPDATE_STATE',
    UPDATE_FILES: 'BRAND_COLOR_EXTRACTOR/UPDATE_FILES',
};

export default CONST;
